module.exports = __webpack_public_path__ + "img/ea71b45.jpg";